import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DigisubservicesService } from '../services/digisubservices.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-paymnet-receiept-very-breifly-officer',
  templateUrl: './paymnet-receiept-very-breifly-officer.component.html',
  styleUrl: './paymnet-receiept-very-breifly-officer.component.scss'
})
export class PaymnetReceieptVeryBreiflyOfficerComponent {


   constructor(
          private dialogRef: MatDialogRef<PaymnetReceieptVeryBreiflyOfficerComponent>,
          @Inject(MAT_DIALOG_DATA) public data: any,
          private service: DigisubservicesService,
          private cdr: ChangeDetectorRef, private fb: FormBuilder, private datePipe: DatePipe
        ) {
        }


        advtFormBeans: any = []
        reportType:any
            startDate :any
            endDate :any
            repName :any
            offRepName:any
            advtName :any
            issueDates:any
            issueDates1:any
          
          PaymentReceiptRegister = new FormGroup({
              start: new FormControl(),
              end: new FormControl(),
              rep_name: new FormControl(),
              off_rep_name: new FormControl(),
              issuename: new FormControl(),
              issueDates:new FormControl(),
            });
            startDate_contract: any;
            enddate_contract: any;
            advtVBTotal: number = 0;
            // PaymentadvtOffInDTotal3: number = 0;
            // PaymentadvtOffInDTotal: number = 0;
            ngOnInit(): void {
          
             debugger
             let repname: any = this.data['repName'];
          
              // Then check if it's not empty and convert to array
              if (repname != "") {
                repname = repname; // This puts the single value in an array
              }
          
              this.reportType = this.data['reportType'];
              this.startDate = this.data['startDate'] === undefined ? '' : this.data['startDate'];
              this.endDate = this.data['endDate'] === undefined ? '' : this.data['endDate'];
              this.repName = this.data['repName'];
              this.offRepName = this.data['offRepName'];
              this.advtName = this.data['name'];
              this.issueDates = this.data.issueDates;
              this.issueDates1 = this.data['issue_date'];
          
          
              const req: any = {
                "rep_name": repname,
                "start_date": this.startDate,
                "end_date": this.endDate,
                "off_rep_name": this.offRepName,
                "advt_name": this.data['name'],
                // // "issue_name" : this.advtName,
                // "issue_date": this.issueDates
                "issue_name": "",
                "issue_date": this.issueDates
            
            
              }


                  // in officer vb
    this.service.getAdvtOfficerVb(req).subscribe((data: any) => {
      console.log("ADVT Data=", data);
      this.advtFormBeans = (data as any);;

      // Reset totals
      this.advtVBTotal = 0;

      // Calculate totals
      for (let repData of this.advtFormBeans) {
        for (let data1 of repData.rep_data) {
          this.advtVBTotal += parseInt(data1.rcv_amt) || 0;
        }
      }
    });


            }

//              printPage4() {
//     // this.show = true;
//     const printSection = document.getElementById('print-section');
//     if (!printSection) {
//       console.error("Print section not found!");
//       return;
//     }

//     const printContent = printSection.innerHTML;

//     const screenWidth = window.screen.availWidth;
//     const windowWidth = 1400;
//     const leftPosition = screenWidth - windowWidth - 50;

//     const printWindow = window.open('', '', `width=${windowWidth},height=1000,top=50,left=${leftPosition},scrollbars=yes`);

//     if (printWindow) {
//       printWindow.document.open();
//       printWindow.document.write(`
//           <html>
//               <head>
//                   <title>Print Report</title>
//                   <style>
//                       @media print {
//                           @page {
//                               size: A3 landscape;
//                               margin: 3mm;
//                           }
//                           body {
//                               font-family: Arial, sans-serif;
//                               margin: 0;
//                               padding: 0;
//                               font-size: 10px !important;
//                           }
//                           .print-section {
//                               width: 100%;
//                               margin: 0 auto;
//                               padding: 0;
//                           }
//                           table {
//                               width: 100% !important;
//                               border-collapse: collapse;
//                               table-layout: auto;
//                               page-break-inside: auto;
//                           }
//                           tr {
//                               page-break-inside: avoid;
//                               page-break-after: auto;
//                           }
//                           th, td {
//                               padding: 3px 5px !important;
//                               border: 1px solid black !important;
//                               font-size: 10px;
//                               line-height: 1.3;
//                               word-wrap: break-word;
//                               overflow-wrap: break-word;
//                           }
//                           th {
//                               background-color: #f2f2f2;
//                           }
//                           tr {
//                               border-bottom: 1px solid black !important;
//                           }
//                           tr.header-row {
//                               display: table-header-group;
//                           }
//                           td:nth-child(1) {
//                               width: 1%;
//                               text-align: left !important;
//                           }
//                           td:nth-child(2),
//                           td:nth-child(3),
//                           td:nth-child(4),
//                           td:nth-child(5),
//                           td:nth-child(6),
//                           td:nth-child(8) {
//                               text-align: left !important;
//                           }
//                           td:nth-child(5) {
//                               width: 5%;
//                               white-space: normal;
//                           }
//                           td.advt-name {
//                               max-width: 160px;
//                               white-space: nowrap;
//                               overflow: hidden;
//                               text-overflow: ellipsis;
//                           }
//                           td:nth-child(n+12),
//                           td.amount,
//                           td[data-type="number"] {
//                               text-align: right !important;
//                           }
//                           td.text,
//                           td[data-type="string"] {
//                               text-align: left !important;
//                           }
//                           .br-right { border-right: 1px solid black !important; }
//                           .br-rightt { border-right: 4px solid black !important; }
//                           .br-bottom { border-bottom: 2px solid black !important; }
//                           .br-top { border-top: 2px solid black !important; }
//                           .noPrint { display: none !important; }
//                           .footer-line {
//                               position: fixed;
//                               bottom: 0;
//                               left: 0;
//                               width: 100%;
//                               height: 2px;
//                               background-color: black;
//                           }
//                           thead { display: table-header-group; }
//                           tfoot { display: table-footer-group; }
//                           td.balance-value {
//                               text-align: right !important;
//                           }
//                       }
//                   </style>
//               </head>
//               <body>
//                   <div class="print-section">
//                       ${printContent}
//                       <div class="footer-line"></div>
//                   </div>
//                   <script>
//                      window.onload = function () {
//     const table = document.querySelector('table');
//     if (!table) {
//         console.error("Table not found");
//         return;
//     }

//     let headerRowIndex = -1;
//     const maxRowsToCheck = Math.min(10, table.rows.length);

//     // Find header row with column names
//     for (let i = 0; i < maxRowsToCheck; i++) {
//         const row = table.rows[i];
//         const cellTexts = Array.from(row.cells).map(cell => cell.textContent.trim());

//         if (row.cells.length >= 8 &&
//             (cellTexts.includes('Invoice No') ||
//              cellTexts.includes('Receipt No') ||
//              cellTexts.includes('Balance'))) {
//             headerRowIndex = i;
//             break;
//         }
//     }

//     if (headerRowIndex >= 0) {
//         // Create thead and move only the actual header row into it
//         let thead = table.querySelector('thead');
//         if (!thead) {
//             thead = document.createElement('thead');
//             table.insertBefore(thead, table.firstChild);
//         }

//         const headerRow = table.rows[headerRowIndex];
//         thead.appendChild(headerRow); // move actual header row

//         // Leave the other rows (like titles) in tbody so they don’t repeat
//     }

//     // Alignment processing (no change needed here)
//     const cells = document.querySelectorAll('td');
//     cells.forEach(cell => {
//         const content = cell.textContent.trim();

//         if (content.includes('येणे') ||
//             content.includes('Opening Balance') ||
//             content.match(/^\d+\s+येणे$/) ||
//             content.includes('Balance C/F') ||
//             content.includes('Total')) {
//             cell.style.textAlign = 'right';
//             cell.classList.add('balance-value');
//         }

//         const numericPattern = /^-?\\d+(,\\d{3})*(\\.\\d+)?$/;
//         if (numericPattern.test(content.replace(/[\\s,]/g, ''))) {
//             cell.style.textAlign = 'right';
//             cell.classList.add('amount');
//         }
//     });

//     setTimeout(() => {
//         window.print();
//         setTimeout(() => { window.close(); }, 500);
//     }, 200);
// };

//                   </script>
//               </body>
//           </html>
//       `);
//       printWindow.document.close();
//     } else {
//       console.error("Failed to open print window.");
//     }
//   }

exportExcel(fileName): void {
  console.log('Export function called with fileName:', fileName);
  
  let element = document.getElementById('print-section');
  console.log('Element found:', element);
  
  if (!element) {
    console.error('Element with ID "print-section" not found in DOM');
    return;
  }
  
  try {
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
    console.log('Worksheet created:', ws);
    
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    
    XLSX.writeFile(wb, fileName + '.xlsx');
    console.log('File should be downloaded');
  } catch (error) {
    console.error('Error during export:', error);
  }
}

}
